import * as THREE from "three";
import {fileExists} from "../Helpers/functions";
import {sendRedrawEvent, sendRedrawSimpleEvent} from "../Helpers/Events";

class Module{

    constructor(model,_obj={}){
        // console.log("class Module => model ",model);
        // console.log("class Module => _obj ",_obj);
        this.heightFromFloor = model.userData.heightFromFloor?model.userData.heightFromFloor:0;
        this.mixer = new THREE.AnimationMixer(model);
        this.model = model;
        this._position = (_obj && _obj.canvasCenter)?_obj.canvasCenter:new THREE.Vector2(0,0);
        this._status = 'close';
        this._angle = 0;
        this.option = _obj.LINKED[0]?_obj.LINKED[0]:null;
        /* Вкл. диван */
        if (this.option)
            this._optionStatus = true;
        else
            this._optionStatus = false;
        this.model.traverse(obj=>{
            if(obj.isGroup && obj.userData.type==='OPTION'){
                obj.visible = true;
            }
        });
        /* / Вкл. диван */
        this.shema = {
            normal: new Image(),
            hover: new Image()
        }
        this.updateShema();
        this.updateSize();
        this.id = _obj.ID?_obj.ID:null;
        this.name = _obj.NAME?_obj.NAME:null;
        this.materials = _obj.MATERIALS?_obj.MATERIALS:{corp:{},face:{},cloth:{},metal:{}}
        this.isModule = true;
        this._corp = null;
        this._face = null;
        this._cloth = null;

        if(this.option) this.materials.cloth = this.option.MATERIALS.cloth;
        // console.log("class Module => this ",this);
    }

    get optionStatus(){
        return this._optionStatus;
    }
    set optionStatus(val){
        if(this._optionStatus!==val){
            this.model.traverse(obj=>{
                if(obj.isGroup && obj.userData.type==='OPTION'){
                    obj.visible = val;
                }
            });
            this._optionStatus = val;
            this.updateShema();
            // this.updateSize();
        }
    }
    set position(p){
        this._position.set(p.x,p.y);
        // this._position.x = p.x
        // this._position.y = p.y
        //this.model.position.set(p.x/100,0.0,p.y/100);
        //this.model.translateX(p.x/100);
        //this.model.translateZ(p.y/100);
        //this.model.matrixWorldNeedsUpdate = true;
    }

    get position(){
        return this._position;
    }

    set angle(a){
        this._angle = a;
        //this.model.children[0].rotation.y = a;
    }

    get angle(){
        return this._angle;
    }

    set corp(m){
        this._corp = m;
        this.model.traverse(e=>{
            if(e.isMesh){
                if(e.material.length>0){
                    e.material.map((_m,i)=>{
                        if(_m.name ==='corp'){
                            e.material[i]=m;
                            this.changeMaterial(e.material[i],m);
                        }
                    })
                }
                else if(e.material.name === 'corp'){
                    this.changeMaterial(e.material,m);
                }
            }
        })

        this.updateShema();
    }
    get corp(){
        let find = false;
        this.model.traverse(e=>{
            if(e.isMesh){
                if(e.material.length>0){
                    e.material.map(_m=>{
                        if(_m.name === 'corp') find=true;
                    })
                }
                else if(e.material.name === 'corp') find=true;
            }
        })
        return find?this._corp:null;
    }
    set face(m){
        this._face = m;
        this.model.traverse(e=>{
            if(e.isMesh){
                if(e.material.length>0){
                    e.material.map((_m,i)=>{
                        if(_m.name ==='face'){
                            this.changeMaterial(e.material[i],m);
                        }
                    })
                }
                else if(e.material.name === 'face'){
                    this.changeMaterial(e.material,m);
                }
            }
        })
        this.updateShema();
    }
    get face(){
        let find = false;
        this.model.traverse(e=>{
            if(e.isMesh){
                if(e.material.length>0){
                    e.material.map((_m,i)=>{
                        if(_m.name ==='face') find=true;
                    })
                }
                else if(e.material.name === 'face') find=true;
            }
        })
        return find?this._face:null;
    }
    set cloth(m){
        this._cloth = m;
        this.model.traverse(e=>{
            if(e.isMesh){
                if(e.material.length>0){
                    e.material.map((_m,i)=>{
                        if(_m.name ==='cloth'){
                            this.changeMaterial(e.material[i],m);
                        }
                    })
                }
                else if(e.material.name === 'cloth'){
                    this.changeMaterial(e.material,m);
                }
            }
        })
        this.updateShema();
    }
    get cloth(){
        let find = false;
        this.model.traverse(e=>{
            if(e.isMesh){
                if(e.material.length>0){
                    e.material.map((_m,i)=>{
                        if(_m.name ==='cloth') find=true;
                    })
                }
                else if(e.material.name === 'cloth') find=true;
            }
        })
        return find?this._cloth:null;
    }

    set status(status){
        // console.log('status(status)',status)
        // console.log('status(status) this',this)
        // console.log('status(status) this.animations',this.animations)
        if(this.model.userData.animations){

            // const root = getRoot(this);
            // console.log('root',root)
            // console.log('this',this)

            this.mixer = new THREE.AnimationMixer(this.model);

            if(status==='open' && this._status==='close'){
                const clip = this.model.userData.animations.find(a=>/open$/i.test(a.name));
                if(clip){
                    const action = this.mixer.clipAction(clip);
                    action.loop = THREE.LoopOnce;
                    action.clampWhenFinished = true;
                    action.play();
                    this._status = 'open';

                    this.model.traverse(o=>{
                        if(o.name === 'podushki') o.visible = false;
                    });
                }
            }else if(status==='close' && this._status==='open'){
                const clip = this.model.userData.animations.find(a=>/close$/i.test(a.name));
                if(clip){
                    const action = this.mixer.clipAction(clip);
                    action.loop = THREE.LoopOnce;
                    action.clampWhenFinished = true;
                    action.play();
                    this._status = 'close';

                    setTimeout(()=>{
                        this.model.traverse(o=>{
                            if(o.name === 'podushki') o.visible = true;
                        });
                    },clip.duration*1000);
                }
            }
        }

        this._status = status;
    }

    get status(){
        return this._status;
    }

    changeMaterial(material,donor){
        //material = donor;
        material.map = donor.map;
        material.reflectivity = donor.reflectivity;
        material.combine = donor.combine;
        material.envMap = donor.envMap;
        material.color = donor.color.clone();
        if(donor.specular) material.specular = donor.specular.clone();
        material.shininess = donor.shininess;
        material.userData.ID = donor.userData.ID;
        material.map.needsUpdate = true;
        material.needsUpdate = true;
    };

    storeScheme = async (fileName, imgRegularData, imgHoverData, modelSize) => {
        const url = '/configurator3d/ajax_modules_from_top.php'
        const data = {
            fileName: fileName,
            imgRegularData: imgRegularData,
            imgHoverData: imgHoverData,
            modelSize: modelSize
        }

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            // const json = await response.json()
            // console.log('Success:', JSON.stringify(json))
        } catch (error) {
            console.error('Error:', error)
        }
    }

    updateShema(){

        if (!this._corp || !this._face || !this._cloth) {
            // console.log('loading materials...')
            return false
        }

        let imgFileName = this.id
        if (this.corp !== null && this.corp !== undefined)
            imgFileName += '_'+this.corp.userData.ID
        if (this.face !== null && this.face !== undefined)
            imgFileName += '_'+this.face.userData.ID
        if (this.cloth !== null && this.cloth !== undefined)
            imgFileName += '_'+this.cloth.userData.ID

        if (this.option)
            imgFileName += (this._optionStatus)?'_optionON':'_optionOFF';

        if (imgFileName === undefined)
            return false

        const imgSrcJSON = '/configurator3d/tmp_images/modules_from_top/'+imgFileName+'.json'

        if (fileExists(imgSrcJSON)) {

            fetch(imgSrcJSON)
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    // console.log('fetch(imgSrcJSON)',data);

                    const shema = new Image();
                    shema.src = data.imgRegularData;

                    const shemaHover = new Image();
                    shemaHover.src = data.imgHoverData;
                    this.shema = {
                        normal:shema,
                        hover:shemaHover
                    }
                    this.size = data.modelSize;
                    sendRedrawSimpleEvent(document.querySelector('#plan'));
                });

        } else {

            const {devicePixelRatio: ratio=1} = window

            const whSizes = 500*2/ratio

            let container = document.createElement( 'canvas' );
            container.width = container.height = whSizes;
            container.style.border = 'none';
            const scene = new THREE.Scene();
            const halfSize = 2.5;
            const camera = new THREE.OrthographicCamera( -halfSize, halfSize, halfSize, -halfSize, 1, 10 );
            camera.position.set( 0, 10, 0 );
            camera.lookAt(new THREE.Vector3(0,0,0));
            const ambientLight = new THREE.AmbientLight( 0xFFFFFF );
            scene.add(ambientLight);

            const spotLight = new THREE.SpotLight( 0xFFFFFF );
            spotLight.power = 0.6;
            spotLight.position.set( 5, 15, 5 );
            spotLight.lookAt(new THREE.Vector3(0,0,0));
            spotLight.castShadow = false;
            // console.log('SPOT',spotLight);

            scene.add(spotLight);
            const oldMatrix = this.model.matrix.clone();
            const oldParent = this.model.parent;


            // const modelGroup = new THREE.Group();
            // modelGroup.add(this.model);
            // modelGroup.computeBoundingBox();
            // const offset = this.model.boundingBox.getCenter().negate();
            // this.model.translate( offset.x, offset.y, offset.z );

            const modelClone = this.model.clone(true)
            // console.log('this.model',this.model)
            if (!this._optionStatus) {
                modelClone.traverse(obj=>{
                    if(obj.isGroup && obj.userData.type==='OPTION'){
                        // console.log('obj',obj)
                        for (let i = obj.children.length - 1; i >= 0; i--) {
                            obj.remove(obj.children[i])
                        }

                    }
                })
            }
            // console.log('modelClone',modelClone)


            const bb = new THREE.Box3()
            bb.setFromObject(modelClone)
            const modelCenter = bb.getCenter()

            // console.log('this.model',this.model)
            // console.log('modelClone',modelClone)
            camera.position.set(modelCenter.x,10,modelCenter.z)

            scene.add(this.model);
            let renderer = new THREE.WebGLRenderer( { canvas:container, antialias: true, alpha: true } );
            renderer.setPixelRatio( window.devicePixelRatio );
            renderer.setSize( whSizes, whSizes );
            renderer.render( scene, camera );


            const shema = new Image();
            shema.src = renderer.domElement.toDataURL();
            ambientLight.color = new THREE.Color(0x009ee3);

            //pointLight.color = 0x5555ff;
            renderer.render( scene, camera );
            const shemaHover = new Image();
            shemaHover.src = renderer.domElement.toDataURL();
            this.shema = {
                normal:shema,
                hover:shemaHover
            }

            scene.traverse(obj=>{
                if(obj.isMesh){
                    obj.geometry.dispose();
                    if(obj.material.length>0){

                        obj.material.map(m=>{m.dispose()});
                    }
                    else{
                        obj.material.dispose();
                    }
                }
            });

            scene.remove(this.model);
            if(oldParent && oldParent.isObject3D){
                oldParent.add(this.model);
            }
            renderer = null;

            this.updateSize();

            const result = this.storeScheme(imgFileName, shema.src, shemaHover.src, this.size)
            sendRedrawSimpleEvent(document.querySelector('#plan'));
        }
    }
    isVisible(mesh){
        let result = true;
        const recursionSearch = (obj)=>{
            if(!obj.visible){ result = false; return;}
            else if(obj.parent) recursionSearch(obj.parent);
            return;
        };
        recursionSearch(mesh);
        return result;
    }

    updateSize(){
        let maxX = 0;
        let minX = 0;
        let maxY = 0;
        let minY = 0;
        const getMatrix = (obj)=>{
            let matrix = new THREE.Matrix4();
            const recursionMatrix = (obj)=>{
                if(obj.parent){
                    if(obj.parent.parent && obj.parent.parent.userData.type!=='MODULE'){
                        // console.log('MULTIPLY ',obj.parent.matrix.clone());
                        matrix.multiplyMatrices(obj.parent.matrix,matrix);
                        recursionMatrix(obj.parent);
                    }
                    return;
                }
                return;
            }
            recursionMatrix(obj);
            return matrix;
        }
        this.model.traverse(obj=>{
            if(obj.isMesh){
                if(this.isVisible(obj)){
                    obj.geometry.computeBoundingBox();
                    const matrix = getMatrix(obj);
                    const max = obj.geometry.boundingBox.max.clone().applyMatrix4(matrix);
                    const min = obj.geometry.boundingBox.min.clone().applyMatrix4(matrix);
                    //console.log('VISIBLE ',maxX,minX,maxY,minY);
                    maxX=Math.max(maxX,max.x);
                    maxY=Math.max(maxY,max.z);
                    minX=Math.min(minX,min.x);
                    minY=Math.min(minY,min.z);
                }
            }
        });
        const result = {
            pivot: {x:Math.abs(-minX*100),y:-minY*100},
            width: Math.abs(maxX-minX)*100,
            height:Math.abs(maxY-minY)*100,
        }
        this.size = result;
    }

    isHover(point){
        const rotatePoint = new THREE.Vector2(point.x,point.y).rotateAround(this.position,this.angle);
        if(
            rotatePoint.x>=this.position.x - this.size.pivot.x &&
            rotatePoint.x<=this.position.x + (this.size.width - this.size.pivot.x) &&
            rotatePoint.y>=this.position.y - this.size.pivot.y &&
            rotatePoint.y<=this.position.y + (this.size.height - this.size.pivot.y)
        ) return true;
        else return false;
    }

    isHoverRotateControl(point){
        const vp = new THREE.Vector2(point.x,point.y).rotateAround(this.position,this.angle);
        const vc = new THREE.Vector2(this.position.x-this.size.width+this.size.pivot.x-10,
            this.position.y-this.size.height+this.size.pivot.y-10);
        // const vc = new THREE.Vector2(this.position.x-this.size.width+this.size.pivot.x-10,
        //     this.position.y-this.size.height+this.size.pivot.y-10);
        return vc.sub(vp).length()<5;
    }

    lookTo(point, clickMousePoint, startAngle){
        let angle1 = point.clone().sub(this.position).angle();
        let angle2 = clickMousePoint.clone().sub(this.position).angle();

        let diff = angle1-angle2;
        let angle = startAngle-diff;
        let angleD = angle * (360 / (Math.PI*2));
        angleD = Math.round(angleD / 5)*5;
        angle = angleD / (180 / Math.PI);
        this.angle = angle;

        // let angle = point.clone().sub(this.position).angle()-Math.PI;
        //
        // if(angle<0) angle+=Math.PI*2;
        // else if(angle>Math.PI*2) angle-=Math.PI*2;
        //
        // let angleD = angle * (360 / Math.PI*2);
        // angleD = Math.round(angleD / 5)*5;
        // angle = angleD / (180 / Math.PI);
        //
        // this.angle = Math.PI*2 - angle;
    }
    clone(){
        const newModel = this.model.clone(true);
        const newModule = new Module(newModel);
        newModule.id = this.id;
        newModule.name = this.name;
        newModule._corp = this._corp;
        newModule._face = this._face;
        newModule._cloth = this._corp;
        newModule.materials = this.materials;
        newModule._status = this._status;
        newModule.animations = this.animations;
        newModule.updateShema();
        return newModule;
    }
}

export default Module;
